import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { IconModule } from '../components/icon';
import { TextFieldModule } from '../components/text-field';
import { FileListComponent } from './components/file-list.component';
import { FileSelectComponent } from './components/file-select.component';
import { FileUploadComponent } from './components/file-upload.component';
import { AcceptsDirective } from './directives/accepts.directive';
import { FileDropDirective } from './directives/file-drop.directive';
import { FileSelectDirective } from './directives/file-select.directive';
import { FileSizeDirective } from './directives/file-size.directive';
import { FileSizePipe } from './pipes/file-size.pipe';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    IconModule,
    TextFieldModule
  ],
  declarations: [
    FileDropDirective,
    FileSelectDirective,
    AcceptsDirective,
    FileSizeDirective,
    FileListComponent,
    FileUploadComponent,
    FileSelectComponent,
    FileSizePipe
  ],
  exports: [
    FileDropDirective,
    AcceptsDirective,
    FileSizeDirective,
    FileUploadComponent
  ]
})
export class FileUploadModule {
}
